import { Select, Spin } from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ISelectOption } from "../../models/utils/selectOption";
import { defaultFilterOption } from "../../utils";
import { useGetDataOnScroll } from "../getDataOnScrollProps/useGetDataOnScrollProps";

import { getCookie } from "typescript-cookie";
import { EntTerritorialsUnits } from "../../models/handBooks/territorialsUnits";
import { EntTerritorialUnitsFilter } from "../../models/filters/territorialUnitsFilter";
import { useLazyGetTerritorialUnitsShortListQuery } from "../../redux/api/handBooksApi/territorialUnitsApi";

interface IProps {
  value?: number | null;
  type?: string[] | null;
  onChange?: (v: number) => void;
}
const SelectMultiTerritorialUnits = (props: IProps) => {
  const { t } = useTranslation();
  const [options, setOptions] = useState<ISelectOption[]>([]);

  const [getData] = useLazyGetTerritorialUnitsShortListQuery();
  const {
    fetching,
    data,
    setData,
    setFetching,
    setFilter,
    scrollHandler,
    setCurrentPage
  } = useGetDataOnScroll<EntTerritorialsUnits, EntTerritorialUnitsFilter>({
    initialFilter: new EntTerritorialUnitsFilter({type: props.type }),
    query: getData
  });

  useEffect(() => {
    const optionss = Array.from(new Set(data)).map((a) => {
      return { label: getCookie('i18next') === 'ky' ? `${a.code} ${a.nameKy}` : `${a.code} ${a.nameRu}` , value: a.id ?? '' };
    });
    setOptions(optionss);
  }, [data]);

  const search = (value?: string) => {
    if (!value) return;
    const filter = new EntTerritorialUnitsFilter();
    filter.name = value;

  
    setFilter(filter);
    setData([]);
    setCurrentPage(0);
    setFetching(true);
  }
  const clear = () => {
    const filter = new EntTerritorialUnitsFilter();
    filter.name = null; 

    setFilter(filter);
    setData([]);
    setCurrentPage(0);
    setFetching(true);
  }
  return (
    
    <Select
      mode="multiple"
      placeholder={t("msg.selectPlaceholder")}
      onClear={clear}
      onSearch={search}
      onPopupScroll={scrollHandler}
      loading={fetching}
      value={props.value}
      onChange={props.onChange}
      options={options}
      
      filterOption={defaultFilterOption}
      showSearch
      style={{width:'100%'}}
      allowClear
      dropdownRender={(menu) => (
        <Spin spinning={fetching}>
          {menu}
        </Spin>
      )}
    />
  );
};

export default SelectMultiTerritorialUnits;
